// removed by extract-text-webpack-plugin
module.exports = {"silver":"color__silver___3tnHZ c-silver","slate":"color__slate___1n2cC c-slate"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-toolbar/ToolbarButton/style/color.css
// module id = 253
// module chunks = 0 13